module.exports = __webpack_public_path__ + "img/Event_3.80203b19.jpg";